import ApiService from './api.service';
import { InsuranceDTO } from '../models/InsuranceDTO';

export default class InsuranceService {
  /**
   * Get insurances
   *
   * @returns {InsuranceDTO[]} a list of InsuranceDTO object
   * @throws ApiError
   */
  public static async fetchInsurances(): Promise<InsuranceDTO[]> {
    return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/insurances`)
      .then((response: any) => {
        return response.data as InsuranceDTO[];
      });
  }
}
